import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const UiSettingsContext = createContext(null);

export function UiSettingsProvider({ children }) {
  const [hiddenNav, setHiddenNav] = useState([]);

  const load = useCallback(() => {
    api.get("/settings/ui")
      .then((r) => setHiddenNav(r.data.hidden_nav || []))
      .catch((e) => console.debug("ui settings load failed", e));
  }, []);

  useEffect(() => { load(); }, [load]);

  const save = useCallback(async (list) => {
    setHiddenNav(list);
    try { await api.put("/settings/ui", { hidden_nav: list }); }
    catch (e) { console.debug("ui settings save failed", e); }
  }, []);

  return (
    <UiSettingsContext.Provider value={{ hiddenNav, reload: load, save }}>
      {children}
    </UiSettingsContext.Provider>
  );
}

export function useUiSettings() {
  return useContext(UiSettingsContext) || { hiddenNav: [], reload: () => {}, save: async () => {} };
}
